import { useState } from "react";
import Permissions from "../../../images/Chant_Permissions.png";
import TabNav from "../../../CommonComponents/TabNav/TabNav";
import FAQ from "./FAQ";
import { faqSections } from "./faqData";

const HelpPage = () => {
  const [tab, setTab] = useState("faq");

  return (
    <div className="col" style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ padding: "12px" }}>
        <TabNav
          items={[
            { key: "faq", label: "FAQ" },
            { key: "new", label: "What's New" },
            { key: "started", label: "Getting Started" },
            { key: "engage", label: "Membership" },
            { key: "match_day", label: "App" },
            { key: "website", label: "Website" },
            { key: "store", label: "Store" },
            { key: "tickets", label: "Tickets" },
            { key: "support", label: "Support" },
          ]}
          activeKey={tab}
          handleTabChange={setTab}
        />
        <div className="mt-0" id="scroll-div">
          {tab === "new" && (
            <div>
              <iframe
                src="https://docs.google.com/presentation/d/18oevOzworx_SSHr1q4h3kioiLAvZXkobmxJNHfem8iA/embed?start=false&loop=false&delayms=30000"
                height={569}
                allowFullScreen={true}
                style={{ width: "100%" }}
              ></iframe>
              <br></br>
              <br></br>
            </div>
          )}
          {tab === "started" && (
            <div>
              <iframe
                src="https://docs.google.com/presentation/d/e/2PACX-1vS_Y1CojYXa-0ky-CuHD4P2VGPrVpl7VUo5N3OPTeATOfOr1Nj3yb1Bf3Sg2c50ZkJ3Y8HPalrmucq0/embed?start=false&loop=false&delayms=30000"
                height={569}
                allowFullScreen={true}
                style={{ width: "100%" }}
              ></iframe>
              <br></br>
              <br></br>
            </div>
          )}
          {tab === "engage" && (
            <div>
              <iframe
                src="https://docs.google.com/presentation/d/1KeVegkihpd3iF_5PHgBtwzHSWxy3qFQ0slRcujHwQ-s/embed?start=false&loop=false&delayms=30000"
                height={569}
                allowFullScreen={true}
                style={{ width: "100%" }}
              ></iframe>
            </div>
          )}
          {tab === "notifications" && (
            <div>
              <p>
                Members control their personal notification settings using the
                'Notifications' link found under 'Profile'.
              </p>
              <p>
                Leaders have the ability to send any message as a notification
                and pin any message as an announcement in the home feed.
                Press/hold on a post to see options.
              </p>
              <p>
                Notifications will be sent when Admin:
                <ul>
                  <li>
                    Publishing events (watch party, tailgate, travel, volunteer,
                    special event) and news/updates. Notifications can be
                    scheduled for a later date
                  </li>
                  <li>Post Group Tickets</li>
                  <li>Publish a poll</li>
                  <li>
                    Launch a Giveaway, including a 10-min warning, closing and
                    winner selection
                  </li>
                  <li>Press/Hold on any chat post to 'Send as Announcement'</li>
                </ul>
              </p>
              <p>
                Members generate notifications when they:
                <ul>
                  <li>
                    First authenticate in Chant which generates a one-time code
                  </li>
                  <li>
                    Post to the Stream or DM (not currently set for chat
                    channels)
                  </li>
                  <li>@mention a member in Chat</li>
                  <li>Invite a member to a private Chat channel</li>
                  <li>Post tickets for sale or request a ticket</li>
                </ul>
              </p>
              <p>
                On Match Day notifications are sent:
                <ul>
                  <li>
                    Inviting members to complete their match predictions
                    (automated)
                  </li>
                  <li>When a Capo unveils the Tifo</li>
                  <li>When a Capo publishes a VAR Poll</li>
                  <li>
                    When a Capo sends a real-time chant alert (share lyrics)
                  </li>
                  <li>More to come as match day features launch</li>
                </ul>
              </p>
              <p>
                Notifications are sent to alert admin when:
                <ul>
                  <li>An admin changes a members permission level</li>
                  <li>A member flags a chat post as inappropriate</li>
                  <li>A member flags a gallery image as inappropriate</li>
                </ul>
              </p>
              <br />
            </div>
          )}
          {tab === "match_day" && (
            <div>
              <iframe
                src="https://docs.google.com/presentation/d/1L4sMCa74cQ1Ax6VvAn3Muip8y8QjKGyaNCarIR_4XMI/embed?start=false&loop=false&delayms=30000"
                height={569}
                allowFullScreen={true}
                style={{ width: "100%" }}
              ></iframe>
            </div>
          )}
          {tab === "permissions" && (
            <div>
              <p>
                After a member has registered in the app you can set their
                leadership permissions in the 'Members' section of the admin
                dashboard to Admin, Capo or Ticket Scanner.
              </p>
              <p>
                The &apos;Leader&apos; role provides access to the Leader Chat
                Streams (Group and Club).
              </p>
              <p>
                Think of a Capo in Chant as a community engagement leader. It
                can be a way to broaden the role of your &apos;in stand&apos;
                Capo or provide a new role for that person in your group who is
                a natural connector.
              </p>
              <br />
              <img src={Permissions} style={{ maxWidth: "100vw" }} />
              <br />
            </div>
          )}
          {tab === "website" && (
            <div>
              <iframe
                src="https://docs.google.com/presentation/d/1GiswNg1rJa7Qm98jkSfuEzes2ZAD5XJiWZYPhnGcj0o/embed?start=false&loop=false&delayms=30000"
                height={569}
                allowFullScreen={true}
                style={{ width: "100%" }}
              ></iframe>
            </div>
          )}
          {tab === "store" && (
            <div>
              <iframe
                src="https://docs.google.com/presentation/d/1qiAk1Uwrun3nSJkqmzNlg5KrsLQJDHkfPrFm8ykulUA/embed?start=false&loop=false&delayms=30000"
                height={569}
                allowFullScreen={true}
                style={{ width: "100%" }}
              ></iframe>
            </div>
          )}
          {tab === "tickets" && (
            <div>
              <iframe
                src="https://docs.google.com/presentation/d/1IJaQjwm2wgZY7HjGp6ZVgn0dXaHtpQDxJ0AbhpQruVo/embed?start=false&loop=false&delayms=30000"
                height={569}
                allowFullScreen={true}
                style={{ width: "100%" }}
              ></iframe>
            </div>
          )}
          {tab === "faq" && <FAQ sections={faqSections} />}
          {tab === "support" && (
            <div>
              <p>
                Have feedback, feature suggestions or a question?
                <br />
                <a
                  target="_blank"
                  href="mailto:support@chant.fan"
                  rel="noopener noreferrer"
                >
                  support@chant.fan
                </a>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HelpPage;
